import { trpc } from '@/shared/api/trpc';

// Settled, not success: a refused edit (window closed, staff picked it up)
// must refresh the row too, so it shows as locked instead of editable.
export const useUpdateOwnTicket = () => {
  const utils = trpc.useUtils();
  return trpc.support.updateOwn.useMutation({
    onSettled: () => {
      utils.support.myList.invalidate();
      utils.support.recentList.invalidate();
    },
  });
};
